import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import { Avatar, Box, Link, Typography } from '@mui/material'
import { MButton } from 'components'
import { ROUTES_PATH } from 'config'
import { color } from 'config/color'
import type React from 'react'

interface FormStatusFormProps {
    formType: string
    status?: boolean
    backToMenu: () => void
}


const FormStatus: React.FC<FormStatusFormProps> = ({ formType, status = false, backToMenu }: FormStatusFormProps) => {
    const primary = status ? color.success[600] : color.error[600]
    const secondary = status ? color.success[50] : color.error[50]

    return (
        <Box display="flex" gap={2} mb={25} flexDirection="column" alignItems="center" justifyContent="center">
            <Avatar sx={{ bgcolor: secondary, width: 80, height: 80 }}>
                {status ? <CheckCircleIcon sx={{ color: primary, width: 40, height: 40 }} /> : <ErrorIcon sx={{ color: primary, width: 40, height: 40 }} />}
            </Avatar>
            <Typography variant="h2" textAlign="center" fontSize={24} color={color.grey[900]} fontWeight={500}>{status ? `${formType} Service request submitted!` : 'Oops! Something went wrong.'}</Typography>
            <Typography textAlign="center" fontSize={16} color={color.grey[700]}>{status ? 'You have successfully created this request.' : 'Please try again.'} If you need help, please <Link fontSize={16} href={ROUTES_PATH.CONTACT_US}>Contact Us</Link>. </Typography>
            <MButton variant="contained" onClick={backToMenu} rounded="true" texttransform="none" size="large">Go back to Services</MButton>
        </Box>
    )
}

export default FormStatus
